import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openAnalyticsSubmenu } from '../sidebarHelpers';

const exploreTrafficTab = (baseUrl, navigate, user) => {
  return {
    id: 'exploreTrafficTab',
    title: 'Explore Traffic Tab',
    steps: [
      {
        selector: `[data-tour="analyticsLink"]`,
        content: <p>Click on the "Analytics" section in the navigation.</p>,
      },
      {
        selector: `[data-tour="dashboardLink"]`,
        content: <p>Click on the "Dashboard" in the navigation.</p>,
        actionBefore: () => openAnalyticsSubmenu('[data-tour="dashboardLink"]'),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/analytics?mainTab=traffic`, true);
        },
        selector: '[data-tour="trafficTab"]',
        content: (
          <p>
            In this tab, you can see info about each of the channels you use to drive traffic to your website and the
            revenue that traffic generates.
          </p>
        ),
      },
      {
        selector: '[data-tour="summaryCardTrafficTab"]',
        content: <p>This is a brief overview of stats for the current period compared to the previous one.</p>,
      },
      {
        selector: '[data-tour="metricsSelector"]',
        content: (
          <p>
            By default we show the stats for the last 14 days, however, you can change the period according to how much
            data you want to see.
          </p>
        ),
      },
      {
        selector: '[data-tour="relevaVsOtherViewChart"]',
        content: (
          <>
            <p>
              This graph shows the dynamic of pageviews from all sources in one graph and the ones Releva influenced in
              the second graph.
            </p>
            <p>
              This can give you information about the overall performance of all Releva elements and whether you need to
              make any changes in their positioning on your website.
            </p>
          </>
        ),
      },
      {
        selector: '[data-tour="storeTrafficSource"]',
        content: (
          <p>
            Here you can see the sources of your traffic and how much of that traffic has been influenced by Releva.
          </p>
        ),
      },
      {
        selector: '[data-tour="storeTrafficMedium"]',
        content: (
          <p>
            This graph gives you details about the top sources of page view by medium so that you can compare which one
            your customers prefer.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exploreTrafficTab'),
  };
};

export default exploreTrafficTab;
